import { ImageValidator, VideoValidator, I18nValidator, LinksValidator, TitleValidator } from '~/validators'
import images from '@/mixins/images'

export default {
  mixins: [images],

  props: {
    logo: {
      type: Object,
      validator: prop => ImageValidator(prop, 'logo'),
    },

    title: {
      type: String,
    },

    titleAnnotations: {
      type: String,
    },

    introduction: {
      type: String,
    },

    body: {
      type: String,
    },

    bodyAnnotations: {
      type: String,
    },

    buttons: {
      type: Array,
      validator: prop => LinksValidator(prop, 'buttons'),
    },

    buttonAnnotations: {
      type: String,
    },

    links: {
      type: Object,
      validator: prop => {
        I18nValidator(prop, 'links')

        return LinksValidator(prop.args, 'links')
      },
    },

    center: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasVideoPlaceholder() {
      return !!this.placeholder?.video
    },

    isTitleTypeString() {
      return typeof this.title === 'string' ? true : false
    },

    centerClasses() {
      if (this.center) return 'hero--center'
    },
  },
}
